module.exports = __webpack_public_path__ + "static/media/Agi02.4de0e2e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Agi02.jpg
// module id = 342
// module chunks = 0